import React from 'react';
import Raven from 'raven-js';
import { Link } from 'react-router-dom';
import request from '../../../request';
import throttle from 'throttle-debounce/throttle';
import { UploadField, SignedUploader } from '@navjobs/upload';

export default ({ companies, types, patients, cancelUpload }) => (
  <ul id="filelist">
    {patients.map(({ company_id, patient_name, study_type_id }) => {
      let company = companies.find(item => item.id === company_id) || {};
      let type = types.find(item => item.id === study_type_id) || {};
      return (
        <SignedUploader
          beforeRequest={({ files }) =>
            request({
              url: 'studies',
              method: 'POST',
              body: {
                size: files[0].size,
                content_type: files[0].type,
                extension: files[0].name.split('.').pop(),
                company_id,
                patient_name,
                study_type_id,
              },
            })}
          request={({ before, files }) => ({
            url: before.url,
            method: 'PUT',
            headers: {
              'Content-Type': files[0].type,
            },
          })}
          afterRequest={({ before, files }) =>
            request({
              url: `studies/${before.id}/finish`,
              method: 'POST',
            })}
          key={patient_name + company_id + study_type_id}
        >
          {({
            onFiles,
            startUpload,
            triggerProgress,
            files,
            progress,
            complete,
            error,
            after,
            before,
            response,
            status,
          }) => {
            if (error)
              Raven.captureMessage('failed uploading study', {
                extra: {
                  error,
                  status,
                  before,
                  reason: response,
                },
              });

            let total = files
              ? parseFloat(
                  Math.round(files[0].size * 0.000001 * 100) / 100
                ).toFixed(2)
              : 0;

            return (
              <li className="downloaditem">
                <div className="basics">
                  <div className="patient">{patient_name}</div>
                  <div className="company" title="1">{company.name}</div>
                </div>

                {files
                  ? <div className="details">
                      <div className="study">{files[0].name}</div>
                      <div className="type" title="1">{type.name}</div>
                      <div className="dash">—</div>
                      <div className="size">
                        {total}
                        {' '}
                        MB
                      </div>
                      <UploadField onFiles={onFiles}>
                        <a className="start" style={{ paddingLeft: 10 }}>
                          Change File
                        </a>
                      </UploadField>
                    </div>
                  : <div className="details">
                      <UploadField onFiles={onFiles}>
                        <button className="study_start">
                          Choose File
                        </button>
                      </UploadField>
                    </div>}

                {files
                  ? complete
                      ? <div className="status">Finished Upload</div>
                      : error
                          ? <div className="status">Failed to Upload</div>
                          : <div className="status">
                              <div className="progress">
                                <div
                                  className="bar"
                                  style={{
                                    width: progress ? `${progress}%` : 0,
                                  }}
                                />
                              </div>
                              <div className="size">
                                {progress
                                  ? `${progress}% - ${parseFloat(Math.round(files[0].size * 0.000001 * progress) / 100).toFixed(2)} / ${total} MB`
                                  : ''}

                              </div>
                            </div>
                  : <div className="sum">
                      <div className="type" title="1">{type.name}</div>
                    </div>}
                {files && !error
                  ? complete
                      ? <div className="actions">
                          <Link
                            className="start"
                            to={{
                              pathname: `/study/${after.id}/`,
                              state: { study: after },
                            }}
                          >
                            View Study
                          </Link>
                        </div>
                      : progress || progress === 0
                          ? <div className="actions">
                              Uploading... <a
                                className="cancel"
                                onClick={() => cancelUpload(patient_name)}
                              >
                                Cancel
                              </a>
                            </div>
                          : <div className="actions">
                              <a
                                className="start"
                                onClick={throttle(1000, startUpload)}
                              >
                                Start
                              </a>
                              {' - '}
                              <a
                                className="cancel"
                                onClick={() => cancelUpload(patient_name)}
                              >
                                Cancel
                              </a>
                            </div>
                  : <div className="actions">
                      <a
                        className="cancel"
                        onClick={() => cancelUpload(patient_name)}
                      >
                        Cancel
                      </a>
                    </div>}

              </li>
            );
          }}
        </SignedUploader>
      );
    })}
  </ul>
);



// WEBPACK FOOTER //
// ./src/views/dashboard/add/items.js